import React from 'react';
// todo separate types based on their context
export type PropertiesTypes = {
  id: number;
  unit: string;
  name: string;
  address: string;
  type: string;
  photoUrl: string | null;
};

export type AnimalsContentTypes = {
  name: string;
  animalType: string;
  animalBreed: string;
  applicationType: string;
  tenantName: string;
  rentalName: string;
  petPhotoUrl: string;
  rentalUnitNumber: string;
  rentalUnit: string;
  animalColors: string[];
  id: number;
  propertyId: number;
  visitation?: boolean;
};

export type PropertiesData = {
  content: PropertiesTypes[];
  totalPages: number;
  totalElementsCount: number;
};

export type IndividualPropertyData = {
  id: number;
  name: string;
  photoUrl: null | string;
  defaultPolicy: {
    name: string;
  };
  address1: string;
  unitCount: number;
};

export type AnimalsData = {
  content: AnimalsContentTypes[];
  totalPages: number;
  totalElementsCount: number;
};

export enum EApplicationType {
  PET = 'Pet',
  SA = 'SA',
  ESA = 'ESA',
  ANIMAL_VISITATION = 'Visitation',
}

export type IndividualAnimalData = {
  name: string;
  type: string;
  tenantName: string;
  rentalName: string;
  petPhotoUrl: string;
  color: string[];
  imageUrls: string[];
  breed: string;
  gender: string;
  ageUnit: string;
  applicationType: string;
  rentalId: string;
  rentalUnitNumber: string;
  age: number;
  weight: number;
  expirationDate: string;
  vaccinatedDate: string;
  houseTrained: string;
};

export type ResidentInfoDataTypes = {
  applicationType: string;
  rentalName: string;
  rentalUnitNumber: string;
  tenantName: string;
};

export type IndividualUnitData = {
  address: string;
  propertyName: string;
};

export type IndividualComplaint = {
  address: string;
  rentalUnit: string | null;
  operatedBy: string;
};

export type IndividualComplaintInfo = {
  complaintType: string;
  status: string;
  createdDate: string;
  message: string;
  photos: [] | string[];
};

export type IndividualComplaintData = {
  complaint: IndividualComplaint;
  complaintInfo: IndividualComplaintInfo;
};

export type RentalNameData = {
  key: string;
  name: string;
};

export type ProfileProps = {
  canCreateContract: boolean;
  customAttributes: { showIntro: string };
  showIntro: string;
  email: string;
  fullName: string;
  id: string;
  impersonated: boolean;
  lastPaymentDetails?: string | null;
  phone: string;
  photo?: string;
  photoPreSignedUrl?: string;
  photoUrl?: string;
  status?: string;
  subscription?: string;
  type?: string;
  username?: string;
};

export type IndividualInfoProps = {
  label: string;
  value: string | number;
  width?: string;
};
